import { k } from "@/utilities/i18n";
import translate from "@/utilities/i18n/getTranslate";
export var sendAndReceiveMessageSteps = [
    {
        title: translate(k.FN_generateApiKey),
        description: translate(k.FN_generateAPIKey),
    },
    {
        title: translate(k.FN_setupNumberWebhook),
        description: translate(k.FN_setUpWebhook),
    },
    {
        title: translate(k.FN_sendFirstMessage),
        description: translate(k.FN_sendFirstMessageInfo),
    },
];
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3RlcHNUaXRsZURlc2NyaXB0aW9uLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsic3RlcHNUaXRsZURlc2NyaXB0aW9uLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sRUFBRSxDQUFDLEVBQUUsTUFBTSxrQkFBa0IsQ0FBQztBQUNyQyxPQUFPLFNBQVMsTUFBTSwrQkFBK0IsQ0FBQztBQUV0RCxNQUFNLENBQUMsSUFBTSwwQkFBMEIsR0FBRztJQUN4QztRQUNFLEtBQUssRUFBRSxTQUFTLENBQUMsQ0FBQyxDQUFDLGlCQUFpQixDQUFDO1FBQ3JDLFdBQVcsRUFBRSxTQUFTLENBQUMsQ0FBQyxDQUFDLGlCQUFpQixDQUFDO0tBQzVDO0lBQ0Q7UUFDRSxLQUFLLEVBQUUsU0FBUyxDQUFDLENBQUMsQ0FBQyxxQkFBcUIsQ0FBQztRQUN6QyxXQUFXLEVBQUUsU0FBUyxDQUFDLENBQUMsQ0FBQyxlQUFlLENBQUM7S0FDMUM7SUFDRDtRQUNFLEtBQUssRUFBRSxTQUFTLENBQUMsQ0FBQyxDQUFDLG1CQUFtQixDQUFDO1FBQ3ZDLFdBQVcsRUFBRSxTQUFTLENBQUMsQ0FBQyxDQUFDLHVCQUF1QixDQUFDO0tBQ2xEO0NBQ0YsQ0FBQyJ9